import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Personal = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    dni: "",
    domicilio: "",
    codigoPostal: "",
    poblacion: "",
    provincia: "",
    telefono: "",
    email: "",
    fechaAntiguedad: null, // Cambiado de "" a null
    funcion: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      fechaAntiguedad: date ? dayjs(date).format("YYYY-MM") : "",
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box>
      <TextField
        fullWidth
        label="Nombre y apellidos"
        name="nombre"
        value={formData.nombre}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="D.N.I."
        name="dni"
        value={formData.dni}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Domicilio (de la empresa)"
        name="domicilio"
        value={formData.domicilio}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Código Postal (C.P.)"
        name="codigoPostal"
        value={formData.codigoPostal}
        onChange={handleChange}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/\D/g, "").slice(0, 5);
        }}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Población"
        name="poblacion"
        value={formData.poblacion}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Provincia"
        name="provincia"
        value={formData.provincia}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Teléfono (de la empresa)"
        name="telefono"
        value={formData.telefono}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        margin="normal"
      />

      {/* Date Picker para Fecha de Antigüedad */}
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <DatePicker
          views={["year", "month"]}
          label="Fecha de antigüedad en la empresa"
          value={
            formData.fechaAntiguedad ? dayjs(formData.fechaAntiguedad) : null
          }
          onChange={handleDateChange}
          sx={{ width: "100%" }} // Asegura que el DatePicker sea full width
          renderInput={(params) => (
            <TextField fullWidth margin="normal" {...params} />
          )}
        />
      </LocalizationProvider>

      <TextField
        fullWidth
        label="Función (Administrador, gerente, etc.)"
        name="funcion"
        value={formData.funcion}
        onChange={handleChange}
        margin="normal"
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Guardar Información
      </Button>
    </Box>
  );
};

export default Personal;
